module.exports = __webpack_public_path__ + "img/Entia-Generacion-de-energia-medio-ambiente-2.74d7e196.webp";